import { VectorType, type IVectorLayerProps } from '@meitu/saas-editor-core/es/version-types';
import { BaseToolbar } from '@/components/base-toolbar';
import { DividerLine } from '@/components/divider-line';
import { useBaseTool } from '@/hooks/use-common-tool';
import { useEditor } from '@/hooks/use-editor';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';
import { type WidgetCommonProps } from '../../types';
import {
    BlurController,
    BorderRadiusController,
    FillColorPicker,
    LayerOpacity,
    PieceColorPicker,
    ReflectionInspector,
    ShadowInspector,
    StrokeInspector,
} from '../../widgets';
import './style.less';

type Props = WidgetCommonProps;

export const VectorImagePanel: React.FC<Props> = ({ layerId, recordId, ...restProps }) => {
    const commonProps: WidgetCommonProps = {
        layerId,
        recordId,
        ...restProps,
    };

    const editor = useEditor();

    const baseTrackCallback = useBaseTool(editor, 9, recordId);

    const props = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;

        const parentId = layer.parentId;
        const layerData = layer.data as IVectorLayerProps;
        const { vectorType } = layerData;

        return {
            parentId,
            vectorType,
        };
    });

    const vectorType = props ? props.vectorType : VectorType.Rect;

    return (
        <div className="vector-image-panel">
            {vectorType === VectorType.Graph ? (
                <PieceColorPicker {...commonProps} />
            ) : (
                <>
                    <div className="vector-image-panel__base">
                        <FillColorPicker {...commonProps} />
                        <BlurController {...commonProps} />
                        <LayerOpacity {...commonProps} />
                        {vectorType === VectorType.Rect ? <BorderRadiusController {...commonProps} /> : null}
                    </div>

                    <DividerLine />

                    <div className="vector-image-panel__effects">
                        <StrokeInspector {...commonProps} />
                        <div className="vector-image-panel__divider" />
                        <ShadowInspector {...commonProps} />
                        <div className="vector-image-panel__divider" />
                        <ReflectionInspector {...commonProps} />
                    </div>
                </>
            )}

            <DividerLine />

            {/* 通用图层工具栏 */}
            <BaseToolbar id={layerId} editor={editor} style={{ padding: '0 16px 16px' }} {...baseTrackCallback} />
        </div>
    );
};
